import { useIntl } from 'react-intl';
import { MarketCode } from '@tink/config/src/markets';
import { isSwedbankOrSavingsbank } from '../../../payments/legacy/components/PaymentDirector/molecules/SwedbankSavingsbankErrorOverlay/SwedbankSavingsbankErrorOverlay';
import { DetailedErrorReason } from '../../../models/credentials';
import { useUrlQuery } from '../../ApplicationProviders/UrlQueryProvider/UrlQueryProvider';
import { TinkErrorReason } from '../../../stores/app-state-errors';
import { messages } from './messages';

type UseCredentialsDetailedErrorDisplayMessagePayload = {
  providerName: string | undefined;
  errorReason: TinkErrorReason;
};

export const useCredentialsDetailedErrorDisplayMessage = ({
  providerName,
  errorReason,
}: UseCredentialsDetailedErrorDisplayMessagePayload) => {
  const { formatMessage } = useIntl();
  const { market } = useUrlQuery();

  if (
    providerName === 'handelsbanken-bankid' &&
    errorReason === DetailedErrorReason.ACTION_NOT_PERMITTED
  ) {
    return {
      title: formatMessage(messages.handelsbankenListTitle),
      body: [
        {
          items: [
            formatMessage(messages.handelsbankenListStepOne),
            formatMessage(messages.handelsbankenListStepTwo),
            formatMessage(messages.handelsbankenListStepThree),
            formatMessage(messages.handelsbankenListStepFour),
          ],
        },
      ],
    };
  }

  if (
    providerName === 'handelsbanken-bankid' &&
    errorReason === DetailedErrorReason.USER_ACTION_REQUIRED_UNSIGNED_AGREEMENT
  ) {
    return {
      title: formatMessage(messages.handelsbankenOverrideTitle),
      body: [{ text: formatMessage(messages.handelsbankenOverrideText) }],
    };
  }

  if (
    isSwedbankOrSavingsbank(providerName) &&
    errorReason === DetailedErrorReason.USER_NOT_A_CUSTOMER
  ) {
    return {
      title: formatMessage(messages.swedbankOverrideTitle),
      body: [{ text: formatMessage(messages.swedbankOverrideText) }],
    };
  }

  if (
    market === MarketCode.SE &&
    errorReason === DetailedErrorReason.THIRD_PARTY_AUTHENTICATION_UNAVAILABLE
  ) {
    return {
      title: formatMessage(messages.allProviderOverrideOneTitle),
      body: [{ text: formatMessage(messages.allProviderOverrideOneText) }],
    };
  }

  if (
    market === MarketCode.SE &&
    errorReason === DetailedErrorReason.DYNAMIC_CREDENTIALS_INCORRECT
  ) {
    return {
      title: formatMessage(messages.allProviderOverrideTwoTitle),
      body: [{ text: formatMessage(messages.allProviderOverrideTwoText) }],
    };
  }

  if (market === MarketCode.SE && errorReason === DetailedErrorReason.USER_CONCURRENT_LOGINS) {
    return {
      title: formatMessage(messages.allProviderOverrideThreeTitle),
      body: [{ text: formatMessage(messages.allProviderOverrideThreeText) }],
    };
  }

  return {
    title: undefined,
  };
};
